import { render, staticRenderFns } from "./shareButton.vue?vue&type=template&id=31c6e512&"
import script from "./shareButton.vue?vue&type=script&lang=js&"
export * from "./shareButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports